export default {
  tip: {
    danger: '此操作有风险！',
    googleCode: '请输入谷歌验证码'
  },
  btns: {
    today: '当天',
    yesterday: '上一天',
    tomorrow: '下一天',
    month: '当月',
    lastMonth: '上月'
  },
  label: {
    form: {
      submitTime: '提交时间',
      merchatNo: '商户账号',
      agentNo: '第三方',
      merchatOrderNo: '交易代码',
      systemOrderNo: '系统编号',
      channelType: '付款方式',
      callbackStatus: '回调状态',
      patchStatus: '补单状态', // comment 备注
      orderStatus: '订单状态',
      remark: '内容',
      description: '笔记', // comment 备注
      amountStart: '起止金额'
    },
    table: {
      // agentNo: "第三方",
      merchatNo: '商户账号',
      systemOrderNo: '系统订单号',
      merchatOrderNo: '商户订单号', // comment 商户订单号
      channelType: '付款方式', // comment 通道类型
      channelCode: '首字母缩写',
      submitAmount: '提交金额',
      paymentAmount: '实际付款',
      handlingFee: '费用', // comment 手续费
      callbackAmount: '实际收到的金额',
      remark: '内容', // comment 描述
      // callbackTime: "所需时间",
      payoutTime: '付款时间', // comment 订单支付时间
      orderStatus: '订单状态', // comment 订单状态
      dispensing: '出款',
      callbackStatus: '回调状态', // comment 商户状态
      description: '笔记', // comment 备注
      patchStatus: '补单状态', // comment 备注
      patcher: '补单人', // comment 备注
      patchType: '补单类型', // comment 备注
      nowAmount: '商户实际收到金额',
      autoPayout: '自动代付'
    },
    list: {
      totalNumber: '总计交易成功数量',
      totalSuccessMoney: '总计交易成功金额',
      totalMoney: '总计收到金额',
      totalfee: '总计费用',
      makeupAmount: '补单金额共计',
      inTranAmountTotal: '收款总金额',
      inTranTotal: '收款总条数',
      outTranAmountTotal: '提款总金额',
      outTranTotal: '提款总条数'
    }
  },
  rules: {
    submitTime: '提交时间不能为空！'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/orders.js